import React from 'react';
import Slider from 'react-slick';
import HeaderSecondary from 'src/components/partners/header-secondary';
import LoginForm from 'src/components/partners/login';
import DottedSmallIcon from 'icons/dotted-small.svg';
import DottedBigIcon from 'icons/dotted-big.svg';
import { sliderData, sliderSettings } from 'src/components/partners/login/constants';
import { LOGIN } from 'src/formMapper';

const Login = () => {
  return (
    <div className='relative min-h-screen'>
      <div className='absolute inset-0 z-0 w-full h-full md:w-1/2 bg-link-water bg-opacity-30' />
      <div className='container relative z-10 px-4 py-4 mx-auto lg:py-6'>
        {/* Header */}
        <HeaderSecondary />
        <div className='grid items-center grid-cols-12'>
          {/* Left Side */}
          <div className='col-span-4'>
            <div className='items-center justify-center hidden px-4 text-center lg:block'>
              <div>
                <h2 className='app-heading-primary text-primary'>
                  {LOGIN.header.login_partner_text} <br />
                  {LOGIN.header.login_partner_text_rem}
                </h2>
                <div className='block'>
                  <Slider {...sliderSettings}>
                    {sliderData.map((step, index) => (
                      <div key={String(index)}>
                        <img className='mx-auto mt-6' src={step.imgUrl} alt={step.title} />
                        <h2 className='mt-4 app-text-dm-large text-secondary'>{step.title}</h2>
                        <p className='mt-1 app-text-dm-small text-gray opacity-80'>{step.description}</p>
                      </div>
                    ))}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
          {/* Right Side */}
          <div className='relative col-span-12 col-start-1 lg:col-span-6 lg:col-start-6'>
            <div className='absolute z-0 hidden -left-11 top-36 sm:block'>
              <DottedBigIcon />
            </div>
            <div className='absolute z-0 hidden -right-16 bottom-36 sm:block'>
              <DottedBigIcon />
            </div>
            <div className='absolute z-0 hidden left-36 -top-7 sm:block'>
              <DottedSmallIcon />
            </div>
            <div className='relative z-10 px-6 py-5 bg-white shadow-card-shadow-secondary rounded-20 lg:px-16 lg:py-12'>
              <div>
                <h2 className='app-heading-main text-primary'>
                  {LOGIN.header.login_partner_hi_there_text} <br />
                  {LOGIN.header.login_partner_hi_there_text_rem}
                </h2>
                <p className='mt-2 app-text-dm-regular text-gray opacity-80'>
                  {LOGIN.subHeader.subHeader_login_partner_text}
                </p>
              </div>
              <div className='mt-8 lg:max-w-md'>
                <LoginForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
